import { Outlet, Navigate } from "@libs/router";
import { StorageService } from "@libs/storage-service";

function readAccessToken(): string | null {
  try {
    return StorageService.get<string>("accessToken");
  } catch {
    return null;
  }
}

export const AuthGuard = () => {
  const accessToken = readAccessToken();
  const isAuthenticated = Boolean(accessToken);

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  return <Outlet />;
};
